import { ImageTypeEnumDTO } from "dev-corize-api-client" 

export class ImageUploadSettings
{
    public maxFiles : number = 1;
    public maxFileSize : number = 500000;
    public imageType : ImageTypeEnumDTO = ImageTypeEnumDTO.Image;
    public fileConcurrency : number = 1;
    public url : string;
    public mimeTypes: Array<string> ;
    public field_name: string ="theImage";
    public method: string ="PUT";
    public uploadType: 'uploadAll' | 'uploadFile' | 'cancel' | 'cancelAll' | 'remove' | 'removeAll' = 'uploadAll';
    public generatePreview : boolean = false;
    public caption:string;
}